module.exports = __webpack_public_path__ + "static/media/frank.6db2e8de.jpg";